// extracted by mini-css-extract-plugin
export default {"iconWithChain":"ProjectAvatar_iconWithChain__glZ28","icon":"ProjectAvatar_icon__+GrY7","chainLogo":"ProjectAvatar_chainLogo__-JcUl"};